// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popupw[data-v-7a7b2576] {\n  font-size: 20px;\n}\n.popupw[data-v-7a7b2576]:hover {\n  opacity: 0.8;\n}\n.namePage[data-v-7a7b2576]:hover {\n  opacity: 0.7;\n}", ""]);
// Exports
module.exports = exports;
